import React from 'react'
import PropTypes from 'prop-types'
import {
    Box,
    Flex,
    Heading,
    Image,
    useMediaQuery
} from '@salesforce/retail-react-app/app/components/shared/ui'
import Card from '../../../components/home-service-section/card'
import Scroller from '../../../components/scroller'
import {contentfulMediaFormatter} from '../../../utils'

const CardsGridSection = ({fields, leftTitle = false}) => {
    const title = fields?.heading && (
        <Heading
            as={fields?.headingType || 'h3'}
            width="100%"
            fontSize="24px"
            fontWeight="500"
            lineHeight="32px"
            fontFamily="Raleway"
        >
            {fields?.heading}
        </Heading>
    )

    if (leftTitle)
        return <CardsGridSectionLeftTitle title={title} cards={fields?.items} />

    return (
        <Flex width="100%" px={{base: '24px', xl: '40px'}} flexFlow="column">
            {title}
            <Flex
                width="100%"
                gap={{base: '24px'}}
                flexFlow={{base: 'column', xl: 'row'}}
                justifyContent="space-between"
                alignItems="center"
            >
                {fields?.items?.map(({sys, fields}, ind) => (
                    <Card
                        key={`${sys?.id}-${ind}`}
                        data={{
                            ...fields,
                            cta: fields?.cta?.fields,
                            theme: fields?.theme?.fields
                        }}
                    />
                ))}
            </Flex>
        </Flex>
    )
}

CardsGridSection.propTypes = {
    fields: PropTypes.shape({
        items: PropTypes.arrayOf(
            PropTypes.shape({
                label: PropTypes.string,
                name: PropTypes.string,
                type: PropTypes.string,
                required: PropTypes.bool,
                placeholder: PropTypes.string,
                errorMessage: PropTypes.string
            })
        ),
        sectionType: PropTypes.string,
        image: PropTypes.object,
        cta: PropTypes.object,
        theme: PropTypes.object,
        heading: PropTypes.string,
        headingType: PropTypes.string
    }),
    leftTitle: PropTypes.bool
}

const CardsGridSectionLeftTitle = ({title, cards}) => {
    const [isDesktop] = useMediaQuery('(min-width: 992px)')

    const items = cards?.map((card, ind) => {
        const assets = contentfulMediaFormatter(card)
        const image =
            !isDesktop && assets?.mobile?.url ? assets?.mobile : assets?.desktop

        return (
            <Box
                key={`${card?.sys?.id}-${ind}`}
                width={{base: 'unset', md: '100%', lg: '253px'}}
                maxW={image?.details?.image?.width ?? '500px'}
            >
                <Image
                    src={image?.url}
                    objectFit="cover"
                    borderRadius="16px"
                    width={{base: 'unset', md: 'inherit'}}
                    maxWidth={{base: '253px', md: '100%', lg: '253px'}}
                />
            </Box>
        )
    })

    return (
        <Flex
            width="100%"
            gap="24px"
            px={{base: '24px', xl: '40px'}}
            flexFlow={{base: 'column', xl: 'row'}}
        >
            {!isDesktop && title}
            <Flex
                width="100%"
                alignItems="center"
                justifyContent="space-between"
                gap={{base: '16px', xl: '24px'}}
                flexFlow={{base: 'column', xl: 'row'}}
            >
                {isDesktop && title}
                {isDesktop && items}
                {!isDesktop && <Scroller data={{items}} />}
            </Flex>
        </Flex>
    )
}

CardsGridSectionLeftTitle.propTypes = {
    title: PropTypes.object,
    cards: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string,
            name: PropTypes.string,
            type: PropTypes.string,
            required: PropTypes.bool,
            placeholder: PropTypes.string,
            errorMessage: PropTypes.string
        })
    )
}

export default CardsGridSection
